import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Grid, Button, LinearProgress, Fade, Paper, Collapse,IconButton, Dialog, DialogTitle, DialogContent,DialogActions } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import FileUpload from "components/Files/Upload";
import {
  getCompanies,  
} from "store/state/companies";
import { addLibor, getLibor, getLiborExcel } from "store/state/libor";
import {recalculatePortfolio, recalculateAllPortfolios } from 'store/state/metrics/metrics';
import {initializeAlertEngine} from 'store/state/notifications';
import LiborTable from "./Table";
import CloseIcon from "@material-ui/icons/Close";
import {PrimaryButton,SecondaryButton} from 'components/Global/Buttons';
import Dropdown from 'components/Global/Dropdown/Dropdown'

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }`
const PortfolioDropdownWrapper = styled.div`
  && {
    margin-top:20px;
    min-height:230px;
  }
`
class Libor extends Component {
  state = {
    error: '',
    selectedCompany: '',
    isRecalculateModalOpen:false,
  }
  componentDidMount() {
    const { getLibor } = this.props;
    this.props.getCompanies({ page: 0, limit: 1000 });
    getLibor();    
  }

  handleUpload = files => {
    const {
      authentication: {
        user: { id }
      }
    } = this.props;    
    this.props.addLibor("libor", id, files[0], "/libor/upload");
  };

  getXLSWorksheet = () => {
    const { getLiborExcel } = this.props;
    getLiborExcel();
  }
  openRecalculateModal = () => {    
    this.setState({
      isRecalculateModalOpen:true
    })
  }
  closeRecalculateModal = () => {    
    this.setState({
      selectedCompany: '',
      isRecalculateModalOpen:false
    })
  }
  onChangeCompanySelection = (selectedCompany) => {    
    this.setState({
      selectedCompany: selectedCompany
    });
  }
  recalculateAllPortfolios = () => {
    this.props.recalculateAllPortfolios();
    this.closeRecalculateModal();
  }
  recalculatePortfolio = () => {
    let {selectedCompany} = this.state;
    this.props.recalculatePortfolio({companyId: selectedCompany.value, companyName: selectedCompany.label});
    this.closeRecalculateModal();
  }
  initializeAlertEngine = () => {
    this.props.initializeAlertEngine();    
  }

  componentDidUpdate(prevProps, prevState){
    const {companies} = this.props;
    const {companies: prevCompanies} = prevProps;
    if(companies !== prevCompanies){
      this.setState({
        companiesWithPortfolios: this.props.companies.map(x => ({label:x.name, value: x.id}))
      })
    }
  }

  renderRecalculateButtons = () => {
    const {companiesWithPortfolios, selectedCompany,isRecalculateModalOpen} = this.state;            
    return (
    <div>
      <div>
        <SecondaryButton onClick={this.recalculateAllPortfolios} >RECALCULATE ALL PORTFOLIOS</SecondaryButton>
      </div>
      <div>
        <SecondaryButton onClick={this.openRecalculateModal}>RECALCULATE SINGLE PORTFOLIO</SecondaryButton>
      </div>
      <div>
        <SecondaryButton onClick={this.initializeAlertEngine}>Initialize Alert Engine</SecondaryButton>
      </div>
      <Fragment>
        <Dialog open={isRecalculateModalOpen} onClose={this.closeRecalculateModal} fullWidth maxWidth="sm">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <DialogTitle>Choose Portfolio</DialogTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.closeRecalculateModal}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>          
          <DialogContent>
            <PortfolioDropdownWrapper>
              <Dropdown 
                label="Company"
                onChange={this.onChangeCompanySelection}
                selectedValue={selectedCompany.value}
                options={companiesWithPortfolios}/>
            </PortfolioDropdownWrapper>
          </DialogContent>
          <StyledDialogActions>                            
            
            <Fragment>
              <SecondaryButton onClick={this.closeRecalculateModal}>Cancel</SecondaryButton>
              <PrimaryButton  onClick={this.recalculatePortfolio}>recalculate portfolio</PrimaryButton>
            </Fragment>
          </StyledDialogActions>
        </Dialog>
      </Fragment>
    </div>  );
  }

  renderFileUpload = () => {    
    const {isLoading} = this.props;    
    const theStyle = {
      minWidth:400
    }
    return (
      <Fragment>
      <div style={theStyle}>
        <Collapse in={!isLoading}>
          <Paper elevation={1}>
            <FileUpload onDrop={this.handleUpload} />
           
          </Paper>
        </Collapse>
        <Fade in={isLoading}>
          <Paper elevation={1}>
            <LinearProgress />
          </Paper>
        </Fade>      
      </div>
      </Fragment>
    );  
  }

  render() {
    const {
      libor,
      authentication: { user }
    } = this.props;


    return (
      <Fragment>
        <form onSubmit={() => this.handleUpload()} id="submit_no_human">
          <DialogContent>
            <Grid container spacing={24}>
              <Grid item xs={4} sm={4}>
                <FormControl
                  fullWidth
                  error={this.state.error}
                  style={{ width: "270px", maxWidth: "270px" }}
                >
                  <FormHelperText
                    id="name-helper-text"
                    style={{ marginBottom: "20px" }}
                  >
                    Sample file:{" "}
                    <Button onClick={this.getXLSWorksheet}>LIBOR-Upload-Model.xlsx</Button>
                  </FormHelperText>               
                    {this.renderFileUpload()}                                                     
                  <FormHelperText id="name-helper-text">
                    {this.state.error}
                  </FormHelperText>
                </FormControl>                
              </Grid>
              <Grid container item xs={4} sm={4} justify="flex-start" alignItems="center">
                {this.renderRecalculateButtons()}
              </Grid>
            </Grid>
          </DialogContent>
        </form>
        <LiborTable
          libor={libor.libor}
          user={user}
          uploadResponse={libor.success}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, libor,loading, metrics, companies }) => ({
  authentication,
  libor,
  isLoading: loading.libor_upload,
  companies: companies.companiesPage ? companies.companiesPage.companies : [],
});

export default connect(
  mapStateToProps,
  { addLibor, 
    getLibor, 
    getLiborExcel,
    recalculatePortfolio,
    recalculateAllPortfolios,
    initializeAlertEngine,
    getCompanies
     }
)(Libor);
